export default {
  docs_welcome: '欢迎来到MBE Wiki',
  docs_introduce_title: '介绍',
  docs_introduce:
    'MBE Wiki，涵盖平台和设备等产品介绍，提供帮助文档、视频以及产品文档等查看功能，帮助您更好地使用平台以及运维设备',
  docs_category_title: '知识分类',
  docs_search_placeholder: '请输入关键字，如名称/创建账户',
  docs_search_category_placeholder: '所有知识分类',
  docs_search_status_placeholder: '所有状态',
  docs_search_button: '全文搜索',
  docs_help_title: '帮助文档',
  docs_manage_title: '文档管理',
  docs_category_manage_title: '分类管理',
  docs_return_list: '返回',
  docs_props: '文档属性',

  docs_search_loading_text: '搜索中...',
  docs_search_result1: '全文搜索共为你找到',
  docs_search_result2: '条结果',
  docs_search_lz: '来自',
  docs_detail_base_info: '基本信息',
  docs_detail_base_status: '状态',
  docs_detail_base_createBy: '创建账户',
  docs_detail_base_createTime: '创建时间',
  docs_detail_base_updateBy: '最近修改账户',
  docs_detail_base_updateTime: '最近修改时间',
  docs_detail_base_description: '文档简介',
  docs_detail_path: '路径',
  docs_status_enable: '启用中',
  docs_status_disable: '已禁用',
  docs_disable: '禁用',
  docs_enable: '启用',

  docs_share_title: '分享文档',
  docs_operation_delete: '确定删除该文档?',
  docs_operation_disable: '确定禁用该文档?',
  docs_operation_enable: '确定启用该文档?',

  docs_title: '文档',
  docs_detail_title: '详情',
  docs_update_title: '更新',
  docs_add_title: '添加',
  docs_add_category_title: '新建分类',
  docs_edit_category_title: '编辑分类',

  // table
  docs_table_title: '标题',
  docs_table_delete_config: '确定删除该文档?',
  docs_table_category_name: '分类名称',
  docs_table_category_description: '分类描述',

  // 表单
  docs_form_add_title: '添加文档',
  docs_form_edit_title: '编辑文档',
  docs_form_edit_prop_title: '编辑属性',
  docs_form_title: '标题',
  docs_form_title_placeholder: '请输入标题',
  docs_form_name: '文档名称',
  docs_form_name_placeholder: '请输入文档名称',
  docs_form_type: '文档类型',
  docs_form_type_placeholder: '请输入文档类型',
  docs_form_type_help:
    '100 表示设备告警信息（alarm）文档，101 表示设备配置信息文档，102 表示设备运行信息文档；其他类型待定',
  docs_form_category: '知识分类',
  docs_form_category_placeholder: '选择知识分类',
  docs_form_description: '文档简介',
  docs_form_description_placeholder: '请输入文档简介',
  docs_form_icon: '文档图标',
  docs_form_icon_placeholder: '只能上传jpg/png文件,且不超过500kb',
  docs_form_auth: '权限',
  docs_form_auth_read: '文档读权限',
  docs_form_auth_write: '文档写权限',
  docs_form_auth_placeholder: '请选择权限等级',
  docs_form_category_name: '请输入分类名称',
  docs_form_category_icon: '分类图标',
  docs_form_docs_icon: '文档图标',
  docs_form_category_delete_confirm: '确定删除该分类？',
  docs_form_content_save_confirm: '确定保存文档内容？',
};
